import { Dimensions } from 'react-native'

export const bottomSheetContentHeight = Dimensions.get('screen').height / 1.5
export const mobileMinWidth = 375
export const modalMaxWidth = 600

// details screens (offer, nft)
export const detailsImgSizeHorizontalLayout = 513
export const detailsImgSizeVerticalLayout = 300

// offers
export const offerTileImgHeight = 122
export const offerTileImgWidth = 100

// navigation
export const webNavBarHeight = 53

// forms and validation
export const requiredAge = 16
export const userDetailsFormWidth = 659
